import { RECEIVE_RFP_DATA, RECEIVE_OTHER_RFPS, UPDATE_ATTACHMENT, UPDATE_ATTACHMENTS, SUBMIT_PROPOSAL, UPDATE_FLEX_DATA, UPDATE_COMMERCIAL_TERMS, UPDATE_SPACE, UPDATE_PARKINGS } from '../actions/rfp'

export function rfpData (state = {}, action) {
	switch (action.type) {
		case RECEIVE_RFP_DATA :
			return {
				...state,
				...action.rfpData
			}

		case UPDATE_COMMERCIAL_TERMS:
			return {
				...state,
				commercialTerms: action.commercialTerms
			}

		case UPDATE_SPACE:
			return {
				...state,
				space: action.space
			}

		case UPDATE_PARKINGS:
			return {
				...state,
				parkings: action.parkings
			}

		case UPDATE_ATTACHMENT :
			const { attachmentId, filename, description } = action.data

			return {
				...state,
				attachments: {
          ...state.attachments[attachmentId],
          description: description
        }
			}
			/*return {
					...state,
					...action.attachments
			}*/

		case UPDATE_ATTACHMENTS :
			return {
				...state,
				attachments: action.attachments
			}

		case SUBMIT_PROPOSAL :
			const { statusId } = action

			return {
				...state,
        statusId
			}

		case UPDATE_FLEX_DATA :
			return {
				...state,
				flexData: action.flexData
			}

		default:
			return state
	}
}

export function otherRFPs (state = {}, action) {
	switch (action.type) {
		case RECEIVE_OTHER_RFPS :
			return {
				...state,
				...action.otherRFPs
			}

		default:
			return state
	}
}


// WEBPACK FOOTER //
// ./src/reducers/rfp.js